import { useEffect, useState } from 'react';

const TOOLBAR_SELECTOR = '[data-tiptap-toolbar="true"]';
const EDITOR_AREA_SELECTOR = '.notion-like-editor-layout';

/**
 * Height for the panel docked under the sticky editor toolbar: down to the bottom of the window, or of
 * the editor area if that ends sooner.
 */
export const useHeaderFooterPanelHeight = (enabled: boolean): number | null => {
  const [height, setHeight] = useState<number | null>(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let frame = 0;
    const measure = (): void => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const toolbarBottom = document.querySelector(TOOLBAR_SELECTOR)?.getBoundingClientRect().bottom;
        const areaBottom = document.querySelector(EDITOR_AREA_SELECTOR)?.getBoundingClientRect().bottom;
        if (toolbarBottom === undefined) return;
        setHeight(Math.max(0, Math.round(Math.min(window.innerHeight, areaBottom ?? window.innerHeight) - toolbarBottom)));
      });
    };
    measure();
    document.addEventListener('scroll', measure, true);
    window.addEventListener('resize', measure);
    return () => {
      cancelAnimationFrame(frame);
      document.removeEventListener('scroll', measure, true);
      window.removeEventListener('resize', measure);
    };
  }, [enabled]);

  return height;
};
